import * as z from "zod";
import { FlipDirection, VisualizationType } from "../constants";

export const topicNameSchema = z.string();

export const topicTypeNameSchema = z.string().nullable();

export const visualizationTypeSchema = z.nativeEnum(VisualizationType);

export const imageRotationSchema = z.number();

export const imageFlipDirectionSchema = z.nativeEnum(FlipDirection);
